<template>
  <component :is="tag" 
             class="fields field-section" 
             :style="{'color': color}"
             >
    <term-link v-if="lastSection.tid" 
               :tid="lastSection.tid" 
               :title="lastSection.title" 
               :url="lastSection.relative_url" 
               :type="lastSection.type"
               >
               {{ truncate(lastSection.title, {length: truncateLength > 0 ? this.truncateLength : 999, separator: /,? +/,}) }}
               </term-link>
  </component>
</template>
<script>
import mixinSection from 'components/mixins/section'
import truncate from 'lodash/truncate'

import TermLink from 'components/term/Link'

export default {
  name: 'field-section',
  mixins: [mixinSection],
  components: {
    TermLink,
  },
  props: {
    sections: [Array, Object],
    tag: {
      type: String,
      default: 'div',
    },
    truncateLength: {
      type: [Number, String],
      default: 999,
    },
    color: {
      type: String,
      default: '',
    },
  },

  data() {
    return {}
  },
  methods: {
    truncate,
  },
}
</script>



// WEBPACK FOOTER //
// Section.vue?ca596a50